import crypto from "crypto";

export const hashId = (id) => {
	return crypto.createHash('sha256')
		.update(id)
		.digest('hex');
};
